(function (Drupal, once) {
  Drupal.behaviors.flexyLayoutsGallery = {
    attach: function (context, settings) {
      once('gallery', '.gallery-element').forEach((element) => {
        // Calculate span
        function getSpanEstimateWidth(size) {
          if (size > 500) {
            return 2;
          }
          if (size > 700) {
            return 3;
          }
          return 1;
        }

        // Gallery logic
        const getGalleryItems = element.querySelectorAll('.gallery__item');
        getGalleryItems.forEach((img) => {
          // Set Grid
          const getImg = img.querySelector('img');
          const imgWidth = getImg.naturalWidth;
          const imgHeight = getImg.naturalHeight;

          img.style.gridColumnEnd = `span ${getSpanEstimateWidth(imgWidth)}`;
          img.style.gridRowEnd = `span ${getSpanEstimateWidth(imgWidth)}`;
        });
      });
    }
  };
})(Drupal, once);
